import React from 'react';
import { Typography } from '@mui/material';
import AlertDialog from '../../../components/AlertDialog';
import PasswordForm from '../../../components/PasswordForm';
import BancameBackdrop from '../../../components/BancameBackdrop';
import { patchSignUpSetPassword } from '../../../queries/authorization';
import analytics from '../../../utils/analytics';

type SetPasswordProps = {
  open: boolean;
  onSuccess: () => void;
  onError: () => void;
  token: string;
}

export default function SetPassword(props: SetPasswordProps) {
  const {
    open, onSuccess, onError, token,
  } = props;
  const [openAlertDialog, setOpenAlertDialog] = React.useState(false);
  const [password, setPassword] = React.useState('');
  const [error, setError] = React.useState(false);
  const [errorForm, setErrorForm] = React.useState(true);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    setOpenAlertDialog(open);
  }, [open]);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      await patchSignUpSetPassword(password, token);
      onSuccess();
    } catch (e) {
      setError(true);
      onError();
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  React.useEffect(() => {
    if (error) {
      setTimeout(() => {
        setError(false);
      }, 1000);
    }
  }, [error]);

  return (
    <>
      {(loading || error) && <BancameBackdrop openBackdrop={loading || error} loadingText={error ? 'Error al configurar contraseña' : 'Configurando contraseña...'} type="loading" />}
      <AlertDialog
        isTriggered={openAlertDialog}
        onCloseAction={() => setOpenAlertDialog(false)}
        closeAfterSubmit
        action={async () => {
          analytics.track('Click Boton', {
            initiator: 'usuario',
            text: 'Continuar',
          });
          await handleSubmit();
        }}
        centerButtons
        maxWidth="xs"
        hideCloseButton="corner"
        submitButtonDisabled={errorForm}
        dialogContent={(
          <>
            <Typography variant="body1" textAlign="center" color="textSecondary">
              Crea una contraseña segura para acceder a tu cuenta
              {' '}
              <b>banca.me</b>
              .
            </Typography>
            <br />
            <PasswordForm
              setPassword={setPassword}
              setError={setErrorForm}
            />
          </>
        )}
        pageCall={{
          name: 'CREAR CONTRASEÑA',
          category: 'LR - FIRMA',
        }}

      />
    </>
  );
}
